import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FC } from 'react';

type HouzzProps = {
    className?: string;
};

const Houzz: FC<HouzzProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'houzz'}
            viewBox="0 0 250 250"
        >
            <polygon points="152.1,241 229.4,241 229.4,107.5 74.7,63.1 74.7,9 20.6,9 20.6,241 97.9,241 97.9,163.7 152.1,163.7" />
        </svg>
    );
};

export default Houzz;
